/* ============================================================
   SIMOVO Contact / Support — interactivity (progressive enhancement)
   Server-rendered page; the contact form posts to Shopify natively.
   This script adds: help-router tabs, single-open FAQ accordion,
   form-topic hint line, and smooth in-page anchor scrolling.
   ============================================================ */
(function () {
  "use strict";

  var HINTS = {
    general: "Tell us what's up \u2014 we read every message.",
    activation: "Add your device model so we can guide you precisely.",
    connection: "Add your order number and the country you're in for the fastest fix.",
    refund: "Add your order number so we can find your purchase.",
    presale: "Let us know your destination and trip length."
  };

  function init(root) {
    if (!root || root.__svoContact) return;
    root.__svoContact = true;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* ---- help router tabs ---- */
    var tabs = $$("[data-svo-topic]");
    var panels = $$("[data-svo-panel]");
    function selectTopic(id) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-svo-topic") === id;
        t.style.background = on ? "#233029" : "#FFFCF6";
        t.style.color = on ? "#F8EEE1" : "#233029";
        t.style.borderColor = on ? "#233029" : "rgba(35,48,41,0.12)";
        var arrow = t.querySelector(".svo-tab-arrow");
        if (arrow) arrow.innerHTML = on ? "\u25CF" : "\u203A";
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute("data-svo-panel") !== id; });
    }
    tabs.forEach(function (t) { t.addEventListener("click", function () { selectTopic(t.getAttribute("data-svo-topic")); }); });

    /* ---- FAQ accordion (single-open) ---- */
    var items = $$("[data-svo-faq]");
    function setFaq(item, open) {
      var body = $(".svo-faq-body", item), sign = $(".svo-faq-sign", item);
      if (body) body.hidden = !open;
      if (sign) sign.innerHTML = open ? "\u2013" : "+";
      item.classList.toggle("svo-faq-open", open);
    }
    items.forEach(function (item) {
      var btn = $("[data-svo-faq-toggle]", item);
      if (btn) btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("svo-faq-open");
        items.forEach(function (o) { if (o !== item) setFaq(o, false); });
        setFaq(item, !isOpen);
      });
      if (item.hasAttribute("data-faq-open")) setFaq(item, true);
    });

    /* ---- form topic hint ---- */
    var sel = $("[data-svo-form-topic]");
    var hint = $("[data-svo-hint]");
    if (sel && hint) sel.addEventListener("change", function () {
      var opt = sel.options[sel.selectedIndex];
      var key = opt ? opt.getAttribute("data-hint-key") : "general";
      hint.textContent = HINTS[key] || HINTS.general;
    });

    /* ---- smooth in-page anchors (account for theme header) ---- */
    function stickyPx() { var v = getComputedStyle(root).getPropertyValue("--svo-contact-anchor"); var n = parseInt(v, 10); return isNaN(n) ? 80 : n; }
    $$('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href").slice(1);
        var el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        var y = el.getBoundingClientRect().top + window.scrollY - (stickyPx() + 12);
        window.scrollTo({ top: y, behavior: "smooth" });
      });
    });

    /* If Shopify redirected back after a successful post, bring it into view */
    if ($(".svo-success") && location.hash.indexOf("contact") > -1) {
      setTimeout(function () { var s = $(".svo-success"); if (s) s.scrollIntoView({ behavior: "smooth", block: "center" }); }, 80);
    }
  }

  function boot() { document.querySelectorAll(".svo-contact[data-svo-root]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector ? e.target.querySelector(".svo-contact[data-svo-root]") : null;
    if (r) { r.__svoContact = false; init(r); }
  });
})();
